@if (!reportSubmitted) {
  <!-- Report form -->
  <div class="report-dialog" role="dialog" aria-modal="true" aria-labelledby="report-dialog-title">
    <h2 id="report-dialog-title" mat-dialog-title>
      <mat-icon aria-hidden="true">flag</mat-icon>
      Report Content
    </h2>

    <mat-dialog-content>
      <p class="report-instructions">
        Why are you reporting this {{ contentLabel }}? Select a reason below.
      </p>

      <mat-radio-group [(ngModel)]="selectedReason" class="reason-list" aria-label="Report reason">
        @for (reason of reasons; track reason) {
          <mat-radio-button
            [value]="reason"
            class="reason-option"
            [attr.data-testid]="'reason-radio-btn-' + reason"
            >>
            {{ getLabel(reason) }}
          </mat-radio-button>
        }
      </mat-radio-group>

      <mat-form-field appearance="outline" class="details-field">
        <mat-label>Additional details (optional)</mat-label>
        <textarea
          matInput
          [(ngModel)]="details"
          rows="3"
          maxlength="500"
          data-testid="report-details-input"
          aria-label="Additional details about why you are reporting this content"
        ></textarea>
      </mat-form-field>

      @if (error) {
        <p class="report-error" role="alert">{{ error }}</p>
      }
    </mat-dialog-content>

    <mat-dialog-actions align="end">
      <button
        mat-button
        type="button"
        (click)="cancel()"
        aria-label="Cancel report"
        data-testid="cancel-report-button"
      >
        Cancel
      </button>
      <button
        mat-flat-button
        color="warn"
        type="button"
        data-testid="submit-report-button"
        [disabled]="!selectedReason || submitting"
        (click)="submit()"
        aria-label="Submit report"
      >
        {{ submitting ? 'Submitting...' : 'Report' }}
      </button>
    </mat-dialog-actions>
  </div>
} @else {
  <!-- Post-report: offer to hide -->
  <div class="report-dialog" role="dialog" aria-modal="true" aria-labelledby="report-success-title">
    <h2 id="report-success-title" mat-dialog-title>
      <mat-icon aria-hidden="true">check_circle</mat-icon>
      Report Submitted
    </h2>

    <mat-dialog-content>
      <p class="report-instructions">
        Thanks for reporting. Your report has been submitted for review.
      </p>
      <p class="report-instructions">
        Would you also like to hide this {{ contentLabel }} from your feed?
      </p>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
      <button
        mat-button
        type="button"
        (click)="doneWithoutHiding()"
        data-testid="hide-content-after-report-button"
        aria-label="No thanks, keep showing the content"
      >
        No thanks
      </button>
      <button
        mat-flat-button
        color="primary"
        type="button"
        data-testid="hide-content-after-report-button"
        (click)="hidePost()"
        [attr.aria-label]="'Hide this ' + contentLabel + ' from your feed'"
      >
        <mat-icon aria-hidden="true">visibility_off</mat-icon>
        Hide {{ contentLabel }}
      </button>
    </mat-dialog-actions>
  </div>
}
